import React, { useContext, useEffect, useState } from 'react'
// import { firebaseApp } from '../firebase/firebase';
import { db } from '../firebase/firebase';
import { collection, doc, setDoc, Timestamp } from "firebase/firestore";
import { ArrowForward } from '@material-ui/icons';
import { CircularProgress, FormControl, FormHelperText, IconButton, InputAdornment, OutlinedInput } from '@material-ui/core';
import classes from './login-styles.module.css'
import ScoreContext from '../store/score-context';
const Login = (props) => {
    const scoreCtx = useContext(ScoreContext);

    const [verified, setVerified] = useState(false);
    const [email, setEmail] = useState('');
    const [logged, setLogged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    useEffect(() => {
        scoreCtx.generateRandomId();
    }, [])
    async function addEmail() {
        await setDoc(doc(db, "MCQ-friends", scoreCtx.randomId.toString()), {
            email: scoreCtx.email,
            startTime: Date.now().toString(),
        })
            .then(async (r) => {
                // console.log('--- ', r);
                setLoading(false)
            }).catch((e) => {
                // console.log(e);
                setLoading(false)
            });
    }
    const onSubmit = async (e) => {
        try {
            e.preventDefault();
            const formData = new FormData(e.target);
            if (ValidateEmail(scoreCtx.email) == 1) {
                setLoading(true);
                setMessage("");
                addEmail(scoreCtx.email).then(() => {
                    props.onLogIn()
                    setLoading(false);
                }).catch((e) => {
                    console.log(e);
                    setLoading(false)
                }).finally(() => {
                    setLoading(false)
                })
            }
            else if (ValidateEmail(scoreCtx.email) == 2) {
                setMessage("You're not allowed to play this game.");
            } else {
                setMessage("Please enter a valid email.");
            }
        } catch (error) {
            console.log("onSubmit Error", error);
        }
        return false;
    };
    function ValidateEmail(mail) {
        //console.log(mail);
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            if (/@amgen.com\s*$/.test(mail)) {
                return 1 // true
            }
            else return 2 // not allowed to play
        }
        return 0; // false
    }
    return (
        <div style={{ zIndex: '3000', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', color: 'white', textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
            <div className={classes.backDrop}>
                <div className={classes.message}>To Play The Game Please Enter Your Email.
                </div>
                <form onSubmit={onSubmit}>
                    <label>
                        <FormControl fullWidth margin="normal">
                            <OutlinedInput
                                disabled={loading}
                                required
                                onChange={(e) => {
                                    // setEmail(e.target.value)
                                    scoreCtx.setEmail(e.target.value)
                                }}
                                className={classes.emailInput}
                                variant="outlined"
                                name="email"
                                type="email"
                                error={message !== ""}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton type="submit" disabled={loading}>
                                            {(loading && (
                                                <CircularProgress
                                                    color="secondary"
                                                    size="1rem"
                                                />
                                            )) || <ArrowForward />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                            <FormHelperText style={{ fontSize: '14px', color: 'red' }}>{message}</FormHelperText>
                        </FormControl>
                        {/* <input type="email" name="email" onChange={(e) => {
                        setEmail(e.target.value)
                    }} style={{ width: 200, height: 50, borderRadius: 8, borderStyle: 'none', fontSize: 20, opacity: 0.7, borderWidth: 1, borderColor: 'black' }} >
                        
                    </input> */}
                    </label>
                    {/* <input style={{ marginLeft: 20, borderRadius: 10, width: 100, height: 40, borderStyle: 'none' }} type="submit" value=">" /> */}
                </form>


            </div>
        </div>
    )
}
export default Login;